
export const automationTypeOptions = [
  { text: 'Horton', value: 'Horton' },
  { text: 'Face', value: 'Face' },
  { text: 'MyOne', value: 'MyOne' },
  { text: 'Otro', value: 'Otro' }
]

export const aluminumColorOptions = [
  { text: 'Natural', value: 'Natural' },
  { text: 'Bronce', value: 'Bronce' },
  { text: 'Negro', value: 'Negro' },
  { text: 'Blanco', value: 'Blanco' },
  { text: 'Otro', value: 'Otro' }
]

export const glassTypeOptions = [
  { text: 'Laminado', value: 'Laminado' },
  { text: 'Crudo', value: 'Crudo' },
  { text: 'Temperado', value: 'Temperado' }
]

export const doorTypeOptions = [
  { text: 'Puerta Abatible derecha', value: 'Puerta Abatible derecha' },
  { text: 'Puerta Abatible izquierda', value: 'Puerta Abatible izquierda' },
  { text: 'Puerta Abatible doble', value: 'Puerta Abatible doble' },
  { text: 'Puerta Corrediza', value: 'Puerta Corrediza' },
  { text: 'Puerta Plegadiza', value: 'Puerta Plegadiza' }
]

export const leafMaterialOptions = [
  { text: 'Contramarco de aluminio', value: 'Contramarco de aluminio' },
  { text: 'Solo vidrio', value: 'Solo vidrio' },
  { text: 'Zócalo de aluminio', value: 'Zocalo de aluminio' }
]

// based on leafMaterial
export const doorConfigurationOptions = [
  { text: 'P-X', value: 'P-X', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio']},
  { text: 'X-P', value: 'X-P', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio']},
  { text: 'X-X-P', value: 'X-X-P', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio']},
  { text: 'P-X-X-P', value: 'P-X-X-P', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio'] },
  { text: 'P-X-X-X-X-P', value: 'P-X-X-X-X-P', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio'] },
  { text: 'P-X-X', value: 'P-X-X', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio'] },
  { text: 'P-X-SX', value: 'P-X-SX', type: ['Contramarco de aluminio'] },
  { text: 'P-SX', value: 'P-SX', type: ['Contramarco de aluminio'] },
  // { text: 'XS-P', value: 'xs-p', type: [] },
  { text: 'P-SX-SX-P', value: 'P-SX-SX-P', type: ['Contramarco de aluminio'] },
  { text: 'O-X', value: 'O-X', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio'] },
  { text: 'O-X-SX', value: 'O-X-SX', type: ['Contramarco de aluminio'] },
  { text: 'O-X-SX-SX-X-O', value: 'O-X-SX-SX-X-O', type: ['Contramarco de aluminio'] },
  { text: 'O-SX', value: 'O-SX', type: ['Contramarco de aluminio'] },
  { text: 'SX-O', value: 'SX-O', type: ['Contramarco de aluminio'] },
  { text: 'SX-P', value: 'SX-P', type: ['Contramarco de aluminio'] },
  { text: 'SO-SX', value: 'SO-SX', type: ['Contramarco de aluminio'] },
  { text: 'SX-SX-SO', value: 'SX-SX-SO', type: ['Contramarco de aluminio'] },
  { text: 'SX-X-O', value: 'SX-X-O', type: ['Contramarco de aluminio'] },
  { text: 'SX-X-P', value: 'SX-X-P', type: ['Contramarco de aluminio'] },
  { text: 'SX-SO', value: 'SX-SO', type: ['Contramarco de aluminio'] },
  { text: 'X-O', value: 'X-O', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio'] },
  { text: 'X-X-O', value: 'X-X-O', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio'] },
  { text: 'O-X-X', value: 'O-X-X', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio'] },
  { text: 'O-X-X-O', value: 'O-X-X-O', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio'] },
  { text: 'O-X-X-X-X-O', value: 'O-X-X-X-X-O', type: ['Zocalo de aluminio', 'Solo vidrio', 'Contramarco de aluminio'] },
  { text: 'O-SX-SX-O', value: 'O-SX-SX-O', type: ['Contramarco de aluminio'] },
  { text: 'SO-SX-SX', value: 'SO-SX-SX', type: ['Contramarco de aluminio'] },
  { text: 'SO-SX-SX-SO', value: 'SO-SX-SX-SO', type: ['Contramarco de aluminio'] },
  { text: 'SO-SX-SX-SX-SX-SO', value: 'SO-SX-SX-SX-SX-SO', type: ['Contramarco de aluminio'] },
  { text: 'P-X-SX-SX-X-P', value: 'P-X-SX-SX-X-P', type: ['Contramarco de aluminio'] }
]

export const glassThicknessFullOptions = [
  { text: '3 + 3', value: '3+3', type: ['Laminado'] },
  { text: '3 + 4', value: '3+4', type: ['Laminado'] },
  { text: '4 + 4', value: '4+4', type: ['Laminado'] },
  { text: '5 + 5', value: '5+5', type: ['Laminado'] },
  { text: '6 + 6', value: '6+6', type: ['Laminado'] },
  // { text: '3', value: '3', type: ['Crudo', 'Temperado'] },
  // { text: '4', value: '4', type: ['Crudo', 'Temperado'] },
  // { text: '5', value: '5', type: ['Crudo', 'Temperado'] },
  { text: '6', value: '6', type: ['Crudo', 'Temperado'] },
  { text: '8', value: '8', type: ['Crudo', 'Temperado'] },
  { text: '10', value: '10', type: ['Crudo', 'Temperado'] },
  { text: '12', value: '12', type: ['Crudo', 'Temperado'] },
  { text: 'Otro', value: 'otro', type: ['Laminado', 'Crudo', 'Temperado'] }
]

export const mountingSurfaceOptions = [
  { text: 'Concreto', value: 'Concreto' },
  { text: 'Metal', value: 'Metal' },
  { text: 'Bloque', value: 'Bloque' },
  { text: 'Otro', value: 'Otro' }
]

export const componentOptions = [
  { text: 'N/A', value: 'n/a' },
  { text: 'Externo', value: 'Externo' },
  { text: 'Interno', value: 'Interno' },
  { text: 'Ambos', value: 'Ambos' }
]

export const conduitOptions = [
  { text: 'Conduit', value: 'Conduit' },
  { text: 'Tubería PVC', value: 'Tuberia PVC' },
  { text: 'Aérea ', value: 'Aerea' }
]

export const breakerOptions = [
  { text: 'Breaker y caja por cliente (std)', value: 'Breaker y caja por cliente' },
  { text: 'Breaker solamente por Accesos', value: 'Breaker solamente por Accesos' },
  { text: 'Breaker y caja por Accesos', value: 'Breaker y caja por Accesos' },
  { text: 'Breaker y caja intemperie por Accesos', value: 'Breaker y caja intemperie por Accesos' }
]